import React from "react";
import CheckCircleOutlineRoundedIcon from "@material-ui/icons/CheckCircleOutlineRounded";

export const CheckCircleIcon = () => <CheckCircleOutlineRoundedIcon />;
